import { Dayjs } from 'dayjs';

import { SystemId } from '@config/system-id';

import { SummitFormattedText } from '@summit/models';
import { EboObject } from '../base-classes/ebo-object';
import { Company } from '../organization/company/company';
import { AliasAssignment } from './alias-assignment';
import { TruckAliasLinehaulRunAssignment } from './truck-alias-linehaul-run-assignment';

export class TruckAlias extends EboObject {
  name: string;
  companyID: string;
  company: Company;
  comment: string;
  hidden: boolean;
  assignments: AliasAssignment[];
  linehaulRunAssignments: TruckAliasLinehaulRunAssignment[];
  supportedHubIds: number[]; //used only for scheduling;

  //HACK for typing For truck sub
  outOfServiceDate: Dayjs;
  outOfServiceTruckStatus: any;
  type: any;
  newStatus: any;

  constructor(jsonData?: Partial<TruckAlias>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.company) {
        this.company = new Company(jsonData.company);
      }
      if (jsonData.assignments) {
        this.assignments = jsonData.assignments
          .map((data) => {
            return new AliasAssignment(data);
          })
          .sort((e1, e2) => e2.startTime.diff(e1.startTime));
      }
      if (jsonData.linehaulRunAssignments) {
        this.linehaulRunAssignments = jsonData.linehaulRunAssignments
          .map((data) => {
            return new TruckAliasLinehaulRunAssignment(data);
          })
          .sort((e1, e2) => e2.startTime.diff(e1.startTime));
      }
    }
    this.companyID ??= SystemId.FedExCompanyID;
    this.assignments ??= [];
    this.linehaulRunAssignments ??= [];
    this.supportedHubIds ??= [];
    this.hidden ??= false;
  }

  get truckAssignment(): SummitFormattedText {
    const response = new SummitFormattedText();
    this.assignments
      .filter((item) => item?.truck)
      .forEach((assignment) => {
        response.AddKeyValues(assignment.getTimeString(), assignment.truck.toShortString());
        if (assignment.comment) {
          response.AddLine(assignment.comment, ['flex', 'flex-row', 'justify-end']);
        }
      });
    return response;
  }

  get companyAssignment(): SummitFormattedText {
    const response = new SummitFormattedText();
    this.assignments
      .filter((item) => item?.settlementCompany)
      .forEach((assignment) => {
        response.AddKeyValues(assignment.getTimeString(), assignment.settlementCompany.toShortString());
        if (assignment.comment) {
          response.AddLine(assignment.comment, ['flex', 'flex-row', 'justify-end']);
        }
      });
    return response;
  }

  get linehaulRunAssignmentsSummary(): SummitFormattedText {
    const response = new SummitFormattedText();
    this.linehaulRunAssignments
      .filter((item) => item?.linehaulRun)
      .forEach((assignment) => {
        response.AddKeyValues(assignment.getTimeString(), assignment.linehaulRun.toShortString());
      });
    return response;
  }

  toShortString(input?: string): string {
    let response = `${this.company ? this.company.name : 'Unk'}-${this.name}`;
    switch (input) {
      case 'N':
        response = `${this.name}`;
        break;
      default:
        break;
    }
    return response;
  }
}
